import type { MediaCategory } from '../../data/dto/media-category.ts'
import { MediaFileService } from '../../data/media-file.service.ts'

const getCategories = async (): Promise<MediaCategory[]> =>
  await MediaFileService.getCategories()

export default getCategories
